export default {
	data() {
		return {
            aboutInfoTab: 'contacts',
			aboutManagementType: 'executiveBoard',
			aboutCurrentYear: '2022',
			aboutHistoryYears: [2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2005],
			aboutInsuranceType: 'investment'
		}
	}
}
